import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FloatingFocusManager, autoUpdate, flip, shift, useClick, useDismiss, useFloating, useInteractions, useRole, } from "@floating-ui/react";
import { GridIcon } from "../Icons/GridIcon";
import { menu, menuButton } from "./ProductMenu.module.css";
import classNames from "classnames";
/**
 * **NOTE**: This is an internal and should only used in testing
 */
export const ControlledProductMenu = ({ className, children, isOpen, setIsOpen, closeOnClick = true, }) => {
    const { refs, floatingStyles, context } = useFloating({
        open: isOpen,
        onOpenChange: setIsOpen,
        middleware: [flip({ fallbackAxisSideDirection: "end" }), shift({})],
        whileElementsMounted: autoUpdate,
    });
    const click = useClick(context);
    const dismiss = useDismiss(context);
    const role = useRole(context);
    const { getReferenceProps, getFloatingProps } = useInteractions([
        click,
        dismiss,
        role,
    ]);
    return (_jsxs(_Fragment, { children: [_jsx("button", { "aria-label": "Toggle Morning Consult products navigation popover", className: classNames(menuButton, className), ref: refs.setReference, ...getReferenceProps(), children: _jsx(GridIcon, {}) }), isOpen && (_jsx(FloatingFocusManager, { context: context, modal: false, children: _jsx("div", { ref: refs.setFloating, style: floatingStyles, "aria-label": "Morning Consult product menu", onClick: () => {
                        if (closeOnClick) {
                            setIsOpen(false);
                        }
                    }, ...getFloatingProps(), children: _jsx("ul", { className: menu, children: children }) }) }))] }));
};
